import { useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { clearErrorMessage, selectUsersStatus } from 'slices/usersSlice'

import { CustomModal } from 'components/common'

import useDeleteUser from 'hooks/useDeleteUser'
import useSubmitResult from 'hooks/useSubmitResult'

type Props = {
  isOpen: boolean
  tenantId: number
  userId: string
  onSuccess: () => void
  onCancel: () => void
}

const TenantUserDelete = ({ isOpen, tenantId, userId, onSuccess, onCancel }: Props) => {
  const [modalErrorMessage, setModalErrorMessage] = useState<string | undefined>(undefined)
  const { isRequesting, errorMessage } = useSelector(selectUsersStatus, shallowEqual)
  const { deleteUser } = useDeleteUser(tenantId)
  const dispatch = useDispatch()

  const { handleSubmit, resetSubmit } = useSubmitResult({
    isRequesting,
    errorMessage,
    onSuccess,
    onError: () => {
      setModalErrorMessage('削除できませんでした。')
      dispatch(clearErrorMessage())
    },
  })

  const handleCancelClick = () => {
    setModalErrorMessage(undefined)
    resetSubmit()
    onCancel()
  }

  const handleDeleteClick = () => {
    handleSubmit()
    deleteUser(userId)
  }

  return (
    <CustomModal
      isOpen={isOpen}
      title="ユーザーアカウント削除"
      approveColor="danger"
      approveLabel="削除"
      errorMessage={modalErrorMessage}
      onCancel={handleCancelClick}
      onApprove={handleDeleteClick}
      onHideNotification={() => setModalErrorMessage(undefined)}
    >
      <div className="pb-4">このユーザーを本当に削除しますか？この操作は取り消せません。</div>
    </CustomModal>
  )
}

export default TenantUserDelete
